{
  "alert": {
    "dataUsage": "Data Usage",
    "fullscreenError": "Failed to enable fullscreen mode!",
    "improveNetwork": "Switch to a different network (e.g., from 3G/4G to Wi-Fi or vice versa)",
    "improveNetwork1": "Move to an area with better signal strength",
    "improveNetwork2": "Check your Wi-Fi device or restart your modem/router",
    "improveNetwork3": "Make sure there aren’t too many devices using the same network",
    "languageMismatch": "Device and application languages do not match",
    "notifyDataLimit": "The amount of data you have used has exceeded the set limit",
    "notifyDataLimit80": "The amount of data you have used has reached 80% of the planned limit",
    "subTitleDataLimit": "Enter the maximum amount of data you wish to use during the call. The system will notify you when your data usage reaches 80% of your specified limit",
    "subTitlePoorNetwork1": "Your connection speed is low, which may affect the quality of your experience (e.g., delays or poor video quality).",
    "subTitlePoorNetwork2": "Change your network connection if possible and try again.",
    "subTitlePoorNetwork3": "If you proceed to join the session under these conditions, your experience may be disrupted, and communication with others could be affected.",
    "subTitlePoorNetwork4": "We recommend improving your network quality before joining the session.",
    "titleDataLimit": "Select unit and enter limit data",
    "titlePoorNetwork": "Slow Connection Detected",
    "unitData": "Unit: MB",
    "unsupportedImageFileFormat": "This file format is not supported. Only JPG, PNG, GIF and SVG files are allowed.",
    "windowCloseFail": "The application cannot close this browser tab or window. Please use browser controls to close it."
  },
  "announcement": {
    "alreadyJoined": "It seems that you have the same AIRe Link session already opened. Please, make sure that you have only one open connection to the same session.",
    "cameraNotAllowed": "AIRe Link is needs permission to use the camera. Access to camera is required to establish the video call. Permission is valid only when this webpage is visible. Search for permission icons in URL bar of your browser and allow access to camera. Then click to \"Try again\" button.",
    "cameraNotAvailable": "The camera is not available. If you want to use it, please allow access.",
    "cameraRestart": "Your camera connection was temporarily interrupted. Please click the restart camera icon on the screen to continue.",
    "clientNotPresent": "The client's video became unavailable. The client may have switched apps. Video will resume once the client returns.",
    "clientWithoutCamera": "The client's camera is not available.",
    "connectionFailed": "Connection failed. You will be reconnected soon."
  },
  "app": {
    "endSessionDuringRecordingConfirm": "Are you sure that you want end session without stop recording?",
    "unloadConfirm": "Are you sure you want to leave the application?"
  },
  "board": {
    "delayed": "A drawing session is in progress"
  },
  "callTab": {
    "elsewhere": {
      "text": "AIRe Link is open in another tab or window on this device. Only one of them can use the camera and microphone. Close the other one, or continue here.",
      "title": "AIRe Link is already open"
    },
    "moved": {
      "text": "The call was moved to another tab or window on this device. This page no longer uses the camera and microphone.",
      "title": "Continued in another tab"
    },
    "useHere": "Use here"
  },
  "commands": {
    "cameraOff": "Camera Off",
    "cameraOn": "Camera On",
    "close": "Close",
    "fullscreen": "Fullscreen",
    "hideToolbar": "Hide Toolbar",
    "joinAgain": "Join Session Again",
    "mute": "Mute",
    "no": "I was not satisfied",
    "showToolbar": "Show Toolbar",
    "submitFeedback": "Submit Feedback",
    "unmute": "Unmute",
    "yes": "I was satisfied"
  },
  "dialog": {
    "button": {
      "cancel": "Cancel",
      "clear": "Clear",
      "confirm": "Confirm",
      "process": "Proceed"
    },
    "clearCanvas": {
      "text": "All drawn or added objects will be deleted. This action can't be undone.",
      "title": "Clear canvas?"
    }
  },
  "droparea": {
    "allowed": "Drop your image here",
    "disallowed": "Can't drop an image here"
  },
  "endCall": {
    "feedback": {
      "issueResolved": "Was the issue resolved?",
      "joinAgain": "Rejoin Session",
      "notResolved": "Not resolved",
      "notSatisfied": "Not satisfied",
      "placeholder": "Why wasn't the issue resolved?",
      "resolved": "Resolved",
      "satisfied": "Satisfied",
      "save": "Save",
      "sessionSatisfaction": "How satisfied were you with this session?",
      "step1": {
        "anotherIssue": "Other (please specify)",
        "issues": {
          "issue1": "Onsite visit required (can’t be resolved remotely)",
          "issue2": "Further action required (e.g. order a spare part)",
          "issue3": "Escalation required (requires another support level)",
          "issue4": "Repeat remote call (due to connection issues)"
        }
      },
      "subIssueResolved": "Your feedback will be saved with the session.",
      "subSessionSatisfaction": "Your feedback will be saved with the session and helps us improve remote support.",
      "subThanks": "Your input helps us improve our service.",
      "thanks": "Thank you for your feedback"
    },
    "join": {
      "agreement": "By using this tool you agree to <a href=\"https://app.aire.link/assets/files/tac/AIReLink_Terms_of_Use_v1.2.pdf\" title=\"Terms of Use\" target=\"_blank\" rel=\"noopener\">Terms of Use</a> and <a href=\"https://app.aire.link/assets/files/privacy-policy/AIReLink_Privacy_Policy_Portal_v1.0.pdf\" title=\"Privacy Policy\" target=\"_blank\" rel=\"noopener\">Privacy Policy</a>"
    }
  },
  "exit": {
    "no": "no",
    "step1": {
      "anotherIssue": "I need to do something else (please specify):",
      "assistant": {
        "feedback": {
          "negative": "No, the issue was not fully resolved",
          "positive": "Yes, the issue was resolved"
        },
        "heading": "Was this call helpful?",
        "subheading": "Please, indicate if the problem was solved. This feedback will be saved with the session.",
        "submitFeedback": "Submit feedback"
      },
      "client": {
        "feedback": {
          "negative": "I was not satisfied",
          "positive": "I was satisfied"
        },
        "heading": "How satisfied were you?",
        "subheading": "Your feedback is important. Please, share with us how you were satisfied.",
        "submitFeedback": "Submit feedback"
      },
      "feedback": {
        "negative": "No, the issue was not fully resolved",
        "positive": "Yes, the issue was resolved"
      },
      "heading": "Was this call helpful?",
      "issues": {
        "issue1": "I need to plan onsite visit (the problem can’t be identified or resolved remotely)",
        "issue2": "I need to manage offline action before follow-up call (e.g. spare part order)",
        "issue3": "I need to escalate to another support level",
        "issue4": "I need to repeat the call later due to bad quality"
      },
      "question": "What was missing to solve the problem?",
      "subheading": "Your feedback is important. Please, share with us if the problem was solved.",
      "submitFeedback": "Submit feedback"
    },
    "step2": {
      "errorHeading": "Connection lost or could not be established",
      "errorSubheading": "To learn more about this error please visit compatibility requirements section <a href=\"https://forum.aire.link/d/8-compatibility-requirements\" target=\"_blank\" rel=\"noopener\">at our forum</a>. If you think it is problem on our end then report it to <a href=\"https://forum.aire.link/forms/27f92cb1-4022-4409-8ebe-705af237a281\" target=\"_blank\" rel=\"noopener\" >our support.</a>",
      "heading": "Thank you for your feedback",
      "invite": "Refer colleagues",
      "joinAgain": "Join the session again",
      "knowledgeBaseInfo": "If you experienced any technical issue with AIRe Link you may report it to our <a href=\"https://forum.aire.link/\" target=\"_blank\">forum</a>. You can also check our <a class=\"font-weight--bold\" href=\"https://forum.aire.link/t/faq\" target=\"_blank\" rel=\"noopener\">FAQ</a> or known <a class=\"font-weight--bold\" href=\"https://forum.aire.link/t/issue\" target=\"_blank\" rel=\"noopener\">issues</a> for possible solutions.",
      "locationsInaccurate": "Locations may not be accurate.",
      "negativeSubheading": "Even if the problem was not fully resolved we believe AIRe Link session is useful for your next steps.",
      "observer": {
        "heading": "Thank you for using AIRe Link",
        "subheading": "We will be pleased if you tell your friends and colleagues about your experience! If you have some spare time you may also read how AIRe Link is helping companies to keep the business <a href=\"https://www.linkedin.com/pulse/we-believe-sustainable-technology-airelink/?trackingId=%2Byvpi7HYR56Vz8Rrb2Whww%3D%3D\" target=\"_blank\" rel=\"noopener\">sustainable</a>."
      },
      "openMap": "Open map",
      "saveMap": "Save map",
      "share": {
        "dynamicMessage": "I just saved {{distance}} and {{emissions}} of CO² with AIRe Link.",
        "linkedin": "Share on LinkedIn",
        "message": "I just saved {distance} km and {emissions} g of CO² with AIRe Link.",
        "staticMessage": "Save time and environment with AIRe Link.",
        "twitter": "Share on Twitter"
      },
      "subheading": "We will be pleased if you tell your friends and colleagues about your experience! If you have some spare time you may also read how AIRe Link is helping companies to keep the business <a href=\"https://www.linkedin.com/pulse/we-believe-sustainable-technology-airelink/?trackingId=%2Byvpi7HYR56Vz8Rrb2Whww%3D%3D\" target=\"_blank\" rel=\"noopener\">sustainable</a>.",
      "summary": {
        "callDuration": "Call duration",
        "co2Saved": "CO² saved",
        "distanceSaved": "Distance saved",
        "heading": "Well done! By using the AIRe Link you just saved your time and <a href=\"https://www.linkedin.com/pulse/we-believe-sustainable-technology-airelink/?trackingId=%2Byvpi7HYR56Vz8Rrb2Whww%3D%3D\" target=\"_blank\" rel=\"noopener\">helped our planet</a>.",
        "subheading": "<a class=\"font-weight--bold\" href=\"https://www.linkedin.com/company/airelink/\" target=\"_blank\" rel=\"noopener\">Like us</a> or use buttons below to spread the word!",
        "timeSaved": "Time saved"
      }
    },
    "yes": "yes"
  },
  "fee": {
    "action": {
      "approve": "Approve",
      "cancel": "Cancel",
      "complete": "Mark as complete",
      "decline": "Decline",
      "submit": "Submit for approval"
    },
    "dateTime": "Date and time of approval",
    "price": "Price",
    "priceLabel": "Enter the price of assistance to the client",
    "suggestion": "The assistant suggests a price for the assistance.",
    "title": "Paid assistance",
    "titleActive": "Active paid assistance"
  },
  "feedback": {
    "issueResolved": "Was the issue resolved?",
    "joinAgain": "Rejoin Session",
    "notResolved": "Not resolved",
    "notSatisfied": "Not satisfied",
    "placeholder": "Why wasn't the issue resolved?",
    "resolved": "Resolved",
    "satisfied": "Satisfied",
    "save": "Save",
    "sessionSatisfaction": "How satisfied were you with this session?",
    "step1": {
      "anotherIssue": "Other (please specify)",
      "issues": {
        "issue1": "Onsite visit required (can’t be resolved remotely)",
        "issue2": "Further action required (e.g. order a spare part)",
        "issue3": "Escalation required (requires another support level)",
        "issue4": "Repeat remote call (due to connection issues)"
      }
    },
    "subIssueResolved": "Your feedback will be saved with the session.",
    "subSessionSatisfaction": "Your feedback will be saved with the session and helps us improve remote support.",
    "subThanks": "Your input helps us improve our service.",
    "thanks": "Thank you for your feedback"
  },
  "indicator": {
    "assistant": {
      "audioDisabled": "Assistant's microphone is unavailable",
      "audioOff": "Assistant's microphone is muted"
    },
    "client": {
      "audioDisabled": "Client's microphone is unavailable",
      "audioOff": "Client's microphone is muted",
      "videoDisabled": "Client's camera is unavailable",
      "videoOff": "Client's camera is off"
    },
    "signal": {
      "warning": "Signal warning"
    }
  },
  "join": {
    "action": {
      "connecting": "Connecting...",
      "joinSession": "Join Session",
      "joiningSession": "Joining...",
      "reconnecting": "Reconnecting to session...",
      "startSession": "Start session"
    },
    "agreement": "By using this tool you agree to <a href=\"https://app.aire.link/assets/files/tac/AIReLink_Terms_of_Use_v1.2.pdf\" title=\"Terms of Use\" target=\"_blank\" rel=\"noopener\">Terms of Use</a> and <a href=\"https://app.aire.link/assets/files/privacy-policy/AIReLink_Privacy_Policy_Portal_v1.0.pdf\" title=\"Privacy Policy\" target=\"_blank\" rel=\"noopener\">Privacy Policy</a>",
    "cameraNotAvailable": "Camera not available",
    "connectionFailed": "Could not connect to the session. Check your internet connection and try again.",
    "enterKey": "Enter your key",
    "enterPin": "Enter your PIN",
    "enterSessionId": "Enter your session ID",
    "microphoneNotAvailable": "Microphone not available",
    "muteCamera": "Mute camera",
    "muteMicrophone": "Mute microphone",
    "pinNotFound": "The PIN is invalid",
    "rateLimited": "Too many PIN verification attempts. Please try again later.",
    "sessionClosed": "Session was closed",
    "sessionExpired": "The session expired",
    "sessionNotFound": "The session ID is invalid",
    "sessionNotStarted": "The session will start at {value}",
    "settings": "Settings",
    "transferSession": "Transfer session",
    "unmuteCamera": "Unmute camera",
    "unmuteMicrophone": "Unmute microphone",
    "usePinMode": "PIN",
    "useSidPidMode": "Key",
    "userAlreadyInSession": "The user is already in session",
    "userNotAuthorized": "User is not authorized to join the session",
    "userNotFound": "User not found"
  },
  "language": {
    "cs-CZ": "Čeština",
    "en-US": "English"
  },
  "languages": {
    "cs-cz": "Čeština",
    "de-de": "Deutsch",
    "en-us": "English",
    "es-es": "Español",
    "fr-fr": "Français",
    "hu-hu": "Magyar",
    "ja-jp": "日本語",
    "nl-nl": "Nederlands",
    "pl-pl": "Polski",
    "pt-pt": "Português",
    "ru-ru": "Русский",
    "zh": "中国人"
  },
  "loader": {
    "action": {
      "cancel": "Cancel"
    },
    "cameraAccessRequest": "AIRe Link is asking for permission to use the camera. Access to camera is required to establish the video call. Permission is valid only when this webpage is visible.",
    "locationAccessRequest": "AIRe Link is asking for permission to access location. We are using location information to estimate savings. Permission is valid only when this webpage is visible. Granting access to location is optional.",
    "microphoneAccessRequest": "AIRe Link is asking for permission to use the microphone. Access to microphone is required to establish audio call. Permission is valid only when this webpage is open.",
    "processingImage": "Processing image ...",
    "reconnectAttempt": "Trying to reconnect. If it is taking too long check your internet connection or refresh this page.",
    "reloadingSession": "Reloading the session...",
    "savingSnapshot": "Saving snapshot",
    "savingUploadedImage": "Saving uploaded image",
    "takingSnapshot": "Taking a snapshot ...",
    "transferringSnapshot": "Transferring snapshot {{progress}}%"
  },
  "lobby": {
    "info": "The session starts when client and assistant are connected.",
    "waitingAssistant": "Waiting for assistant ...",
    "waitingAssistantClient": "Waiting for assistant and client ...",
    "waitingClient": "Waiting for client ..."
  },
  "meeting": {
    "alert": {
      "notifyDataLimit": "The amount of data you have used has exceeded the set limit",
      "notifyDataLimit80": "The amount of data you have used has reached 80% of the planned limit",
      "titlePoorNetwork": "Slow Connection Detected",
      "unsupportedImageFileFormat": "This file format is not supported. Only JPG, PNG, GIF and SVG files are allowed."
    },
    "announcement": {
      "cameraNotAvailable": "The camera is not available. If you want to use it, please allow access.",
      "connectionFailed": "Connection failed. You will be reconnected soon."
    },
    "app": {
      "unloadConfirm": "Are you sure you want to leave the application?"
    },
    "board": {
      "delayed": "A drawing session is in progress"
    },
    "chat": {
      "inputPlaceholder": "Type a new message"
    },
    "commands": {
      "cameraOff": "Camera Off",
      "cameraOn": "Camera On",
      "fullscreen": "Fullscreen",
      "mute": "Mute",
      "unmute": "Unmute"
    },
    "configuration": {
      "camera": "Camera",
      "mic": "Mic"
    },
    "devices": {
      "microphone": "Microphone",
      "speaker": "Speaker"
    },
    "leave": "Leave",
    "loader": {
      "savingSnapshot": "Saving snapshot",
      "savingUploadedImage": "Saving uploaded image"
    },
    "lobby": {
      "waitingAssistant": "Please wait for an assistant to start the remote session.",
      "waitingAssistantClient": "Waiting for assistant and client ...",
      "waitingClient": "Please wait for client to join session."
    },
    "notification": {
      "cameraIssue": "Camera issue detected. Please restart your camera.",
      "clientCameraIssue": "Client camera issue detected. Please ask the client to restart their camera.",
      "liveCaptionStarted": "Transcript started",
      "liveCaptionStopped": "Transcript stopped",
      "lostConnection": "{{ role }} lost network connection",
      "ocrAnalysing": "Recognizing the text, please wait ...",
      "ocrFound": "{{lines}} lines of text recognized!",
      "ocrNotFound": "No text was recognized in the snapshot!",
      "participantReconnected": "The  {{ role }} is back online.\n",
      "reconnecting": "Connection lost, reconnecting...",
      "recordingStarted": "Recording started",
      "recordingStopped": "Recording stopped",
      "snapshotSaved": "Snapshot saved to Media Library",
      "startingRecording": "Starting recording...",
      "stoppingRecording": "Stopping recording...",
      "userReconnected": "You are reconnected"
    },
    "notifications": {
      "clipboardCopy": "Copied to clipboard!",
      "clipboardCopyError": "Can't copy to clipboard!",
      "removedFromClipboard": "Removed from clipboard"
    },
    "participants": {
      "add": "Add participant",
      "title": "Participants"
    },
    "roleExchange": {
      "acceptMessage": "Accept",
      "acceptedMessage": "Role accepted",
      "canceledMessage": "Your request to switch roles was declined",
      "changedRoleMessage": "Your role has been changed to {{role}}",
      "deniedMessage": "Role declined",
      "denyMessage": "Deny",
      "modalTitle": "Do you accept assistant role?",
      "offerMessage": "You've been asked to take the {{role}} role. If you accept you will be given full control over the call.",
      "waitingMessage": "Waiting for response"
    },
    "snapshot": {
      "assistantTaking": "The assistant is taking a snapshot",
      "cancel": "Cancel",
      "holdStill": "Please hold still",
      "taking": "Taking snapshot..."
    },
    "stream": {
      "video": {
        "loading": "Video loading..."
      }
    },
    "toast": {
      "action": {
        "cancel": "Cancel"
      }
    },
    "toolbar": {
      "color": "Color",
      "ocr": "OCR",
      "pen": "Pen",
      "point": "Point",
      "record": "Record",
      "remove": "Remove",
      "resume": "Resume",
      "save": "Save",
      "select": "Select",
      "shapes": "Shapes",
      "share": "Share",
      "snapshot": "Snapshot",
      "stopRecording": "Stop",
      "stopShare": "Stop",
      "text": "Text",
      "weight": "Weight"
    },
    "tools": {
      "camera": "Camera",
      "chat": "Chat",
      "light": "Light"
    },
    "transcript": {
      "header": "Transcript"
    }
  },
  "notification": {
    "assistantIsScreensharing": "Assistant is screensharing",
    "clientIsScreensharing": "Client is screensharing",
    "clipboardCopy": "Copied to clipboard!",
    "clipboardCopyError": "Can't copy to clipboard!",
    "liveCaptionStarted": "Transcript started",
    "liveCaptionStopped": "Transcript stopped",
    "lostConnection": "{{ role }} lost network connection",
    "ocrAnalysing": "Recognizing the text, please wait ...",
    "ocrFound": "{{lines}} lines of text recognized!",
    "ocrNotFound": "No text was recognized in the snapshot!",
    "participantReconnected": "The  {{ role }} is back online.\n",
    "reConnectionSucceed": "The  {{ role }} has successfully reconnected to the network.\n ",
    "reconnecting": "Connection lost, reconnecting...",
    "recordingFailed": "Recording failed, please try again...",
    "recordingStarted": "Recording started",
    "recordingStopped": "Recording stopped",
    "screensharingStartedAssistant": "You are screensharing",
    "screensharingStartedClient": "The assistant is screensharing",
    "screensharingStopped": "Screensharing is turned off",
    "snapshotCreated": "A snapshot has been created",
    "snapshotSaved": "Snapshot saved",
    "startingRecording": "Starting recording...",
    "startingScreensharing": "Starting screensharing",
    "stoppingRecording": "Stopping recording...",
    "userReconnected": "You are reconnected",
    "youAreScreensharing": "You are screensharing"
  },
  "notifications": {
    "clipboardCopy": "Copied to clipboard!",
    "clipboardCopyError": "Can't copy to clipboard!",
    "endSessionDuringRecording": "Ending session during recording may cause your video to be lost or the data to be inaccurate",
    "ocrAnalysing": "Recognizing the text, please wait ...",
    "ocrNotFound": "No text was recognized in the snapshot!",
    "removedFromClipboard": "Removed from clipboard"
  },
  "participants": {
    "header": "Participants",
    "pin": "PIN:",
    "subtitle": {
      "assistant": "Assistant",
      "client": "Client",
      "observer": "Observers"
    },
    "title": "Members"
  },
  "permissions": {
    "actions": {
      "continue": "Continue",
      "tryAgain": "Try again"
    },
    "audioinput": {
      "askingText": "Checking microphone...",
      "deniedText": "Microphone access denied",
      "grantedText": "Microphone access granted",
      "manualLinkText": "How to allow access to microphone?",
      "note": "Recommended",
      "title": "Microphone"
    },
    "location": {
      "askingText": "Checking your location...\n",
      "deniedText": "Location access denied",
      "grantedText": "Location access granted",
      "manualLinkText": "How to allow access to location?",
      "note": "Optional",
      "title": "Location"
    },
    "text": "Permissions are effective only when this page is opened in browser. Local files can't be accessed.",
    "title": "Permissions check",
    "videoinput": {
      "askingText": "Checking webcam...",
      "deniedText": "Webcam access denied",
      "grantedText": "Webcam access granted",
      "manualLinkText": "How to allow access to webcam?",
      "note": "Required",
      "title": "Webcam"
    }
  },
  "preCall": {
    "alert": {
      "clientWaiting": "Your client is waiting for you to join.",
      "subTitlePoorNetwork1": "Your connection speed is low, which may affect the quality of your experience (e.g., delays or poor video quality)."
    },
    "announcement": {
      "alreadyJoined": "It seems that you have the same AIRe Link session already opened. Please, make sure that you have only one open connection to the same session."
    },
    "commands": {
      "cameraOff": "Camera Off",
      "cameraOn": "Camera On",
      "mute": "Mute",
      "unmute": "Unmute"
    },
    "devices": {
      "microphone": "Microphone",
      "speaker": "Speaker"
    },
    "join": {
      "action": {
        "joinSession": "Join Session",
        "joiningSession": "Joining..."
      },
      "agreement": "By using this tool you agree to <a href=\"https://app.aire.link/assets/files/tac/AIReLink_Terms_of_Use_v1.2.pdf\" title=\"Terms of Use\" target=\"_blank\" rel=\"noopener\">Terms of Use</a> and <a href=\"https://app.aire.link/assets/files/privacy-policy/AIReLink_Privacy_Policy_Portal_v1.0.pdf\" title=\"Privacy Policy\" target=\"_blank\" rel=\"noopener\">Privacy Policy</a>",
      "connectionFailed": "Could not connect to the session. Check your internet connection and try again.",
      "pinNotFound": "The PIN is invalid",
      "sessionClosed": "Session was closed",
      "sessionExpired": "The session expired",
      "sessionNotFound": "The session ID is invalid",
      "sessionNotStarted": "The session will start at {value}",
      "userAlreadyInSession": "The user is already in session",
      "userNotAuthorized": "User is not authorized to join the session",
      "userNotFound": "User not found"
    },
    "permissions": {
      "instruction": "#todo To allow access to your {{device}} click on the lock icon and turn on {{device}}.",
      "ok": "OK",
      "title": "Access to your {{device}} is blocked"
    }
  },
  "qrcode": {
    "cancel": "Cancel",
    "heading": "Transfer session",
    "instructions": "Scan the QR code on your other device"
  },
  "roleExchange": {
    "acceptMessage": "Accept",
    "acceptedMessage": "Role accepted",
    "canceledMessage": "Your request to switch roles was declined",
    "changedRoleMessage": "Your role has been changed to {{role}}",
    "deniedMessage": "Role declined",
    "denyMessage": "Deny",
    "modalTitle": "Do you accept assistant role?",
    "offerMessage": "You've been asked to take the {{role}} role. If you accept you will be given full control over the call.",
    "offeredRoleMessage": "You've been asked to take the {{role}} role. If you accept you will be given full control over the call.",
    "waitingMessage": "Waiting for response"
  },
  "settings": {
    "assistant": "Assistant",
    "cameraNotAvailable": "Camera {{camera}} is not available",
    "defaultDevice": "Default device",
    "disabledCamera": "Your camera is disabled.",
    "disabledCameraDescription": "To change the camera please first enable it.",
    "done": "Done",
    "echoWarning": "Selecting a different microphone and speaker may cause an echo.",
    "enable": "Enable",
    "howToEnableCamera": "Learn how to enable camera",
    "howToEnableMicrophone": "Learn how to enable microphone",
    "mediaSettings": "Media settings",
    "microphoneNotAvailable": "Microphone {{microphone}} is not available",
    "mutedMicrophone": "Your microphone is disabled.",
    "mutedMicrophoneDescription": "To change the microphone please first unmute it.",
    "restart": "Restart Devices",
    "selectCamera": "Select camera",
    "selectLanguage": "Select language",
    "selectMicrophone": "Select microphone",
    "selectSpeaker": "Select speaker",
    "selectYourPreferredDevice": "Select your preferred devices.",
    "testSound": "Test sound",
    "unmute": "Unmute microphone"
  },
  "stream": {
    "video": {
      "loading": "Video loading...",
      "placeholder": "Camera stream is not available"
    }
  },
  "toast": {
    "action": {
      "cancel": "Cancel",
      "close": "Close",
      "enterAgain": "Enter again"
    },
    "amountApproved": "The amount was approved",
    "amountDeclined": "The amount was declined",
    "info": {
      "pin": "Ask the client to open client.aire.link. Give them this PIN to enter on the page and join the session."
    },
    "waitingClientApproval": "Waiting for client approval"
  },
  "tools": {
    "cameraOff": "Turn camera off",
    "cameraOn": "Turn camera on",
    "chat": "Chat",
    "clearCanvas": "Clear canvas",
    "clientLight": "Client light",
    "close": "Close",
    "color": "Color",
    "confirm": "Confirm",
    "delete": "Delete",
    "discardText": "Discard text",
    "dismissSnapshot": "Dismiss snapshot",
    "done": "Done",
    "endSession": "End session",
    "fee": "Paid assistance",
    "fullScreenMode": "Fullscreen mode",
    "moreTools": "More tools",
    "mute": "Mute microphone",
    "panningTool": "Panning tool",
    "pointerTool": "Pointer tool",
    "recognizeText": "Recognize text",
    "recordSession": "Record session",
    "redo": "Redo",
    "saveAndClose": "Save and close",
    "saveSnapshot": "Save snapshot",
    "selectionTool": "Selection tool",
    "settings": "Settings",
    "shape": "Shape",
    "shapes": {
      "circle": "Circle",
      "freedraw": "Pen",
      "rect": "Rectangle",
      "text": "Text"
    },
    "startLiveCaption": "Start transcript",
    "startRecording": "Start recording",
    "startScreensharing": "Start screensharing",
    "stopLiveCaption": "Stop transcript",
    "stopRecording": "Stop recording",
    "stopScreensharing": "Stop screensharing",
    "stroke": "Stroke",
    "takeSnapshot": "Take snapshot",
    "turnOffClientLight": "Turn off client light",
    "turnOnClientLight": "Turn on client light",
    "undo": "Undo",
    "unmute": "Unmute microphone",
    "uploadImage": "Upload image"
  },
  "transcript": {
    "header": "Transcript"
  },
  "video": {
    "disabledPreview": "You are now sharing your screen. Webcam preview is disabled during screen sharing.",
    "fix": {
      "activate": "Click to activate the video"
    },
    "modal": {
      "confirm": "Got it",
      "description": "You can control the display with gestures <b>Move</b>, <b>Zoom In</b>, <b>Zoom Out</b> in the same way as you normally view photos on your smartphone.",
      "move": "Move",
      "title": "Did you know that?",
      "zoomIn": "Zoom In",
      "zoomOut": "Zoom Out"
    }
  }
}